// Time entry activity ids are records in the task-management service's own database, so they differ per environment.
export const ST_SPENT_TIME_ACTIVITY_ID = {
  OFFICE: Number(process.env.REACT_APP_DAVINCI_FRONTEND_ST_SPENT_TIME_ACTIVITY_ID_OFFICE),
  HOME: Number(process.env.REACT_APP_DAVINCI_FRONTEND_ST_SPENT_TIME_ACTIVITY_ID_HOME),
  TRANSIT: Number(process.env.REACT_APP_DAVINCI_FRONTEND_ST_SPENT_TIME_ACTIVITY_ID_TRANSIT),
};
